import axios from "@/libs/api.request";

export const getCategoryTreeTableData = filterCond => {
  return axios.request({
    url: "artical/getCategoryTreeTableData",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

export const getCategoryTreeSelect = () => {
  return axios.request({
    url: "artical/getCategoryTreeSelect",
    csrf: false,
    method: "post"
  });
};
export const storeCategoryData = data => {
  return axios.request({
    url: "artical/storeCategoryData",
    data: data,
    method: "post"
  });
};

export const removeCategoryData = id => {
  return axios.request({
    url: "artical/removeCategoryData",
    data: { id },
    method: "post"
  });
};

export const storeArticalData = data => {
  return axios.request({
    url: "artical/storeArticalData",
    data: data,
    method: "post"
  });
};

export const getArticalList = filterCond => {
  return axios.request({
    url: "artical/getArticalList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

export const getArticalById = id => {
  return axios.request({
    url: "artical/getArticalById",
    data: { id },
    csrf: false,
    method: "post"
  });
};

export const removeArticalData = id => {
  return axios.request({
    url: "artical/removeArticalData",
    data: { id },
    csrf: false,
    method: "post"
  });
};
